var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcCloseThin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "39px",
    viewBox: "0 0 39 39",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5 0.378679656 38.6213203 2.5 21.621 19.5 38.6213203 36.5 36.5 38.6213203 19.5 21.621 2.5 38.6213203 0.378679656 36.5 17.379 19.5 0.378679656 2.5 2.5 0.378679656 19.5 17.379z",
    id: "ic_close_thin",
    fill: "#ffffff",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCloseThin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_close_thin.83375b29.svg";
export { ForwardRef as ReactComponent };